export const UNICHAIN_UNISWAP_V3_QUOTER_V2_CONTRACT_ADDRESS =
    '0x385A5cf5F83e99f7BB2852b6A19C3538b9FA7658';

export const UNICHAIN_UNISWAP_V3_FACTORY_CONTRACT_ADDRESS =
    '0x1F98400000000000000000000000000000000003';

export const UNICHAIN_UNISWAP_V3_SWAP_ROUTER_CONTRACT_ADDRESS =
    '0x73855d06DE49d0fe4A9c42636Ba96c62da12FF9C';
